import Cookies from 'js-cookie';

// HubSpot v2 category ids in __hs_cookie_cat_pref: 1 analytics, 2 advertisement, 3 functionality.
const CATEGORY_BY_COOKIE = {
  wmc: '1',
  _gcl_aw: '2'
};

const categoryAllowed = (cookieName, preference) => {
  const category = CATEGORY_BY_COOKIE[cookieName];
  if (!category) return true;

  return preference.split(/[,_]/).includes(`${category}:true`);
};

export const getCookie = key => Cookies.get(key);

export const setCookie = (name, value, expiration, domain) => {
  const date = new Date();
  date.setTime(date.getTime() + expiration);

  document.cookie = `${name }=${ value };expires=${ date.toUTCString() };domain=${ domain };path=/`;
};

export const getCookieValueIfConsent = key => {
  const preference = Cookies.get('__hs_cookie_cat_pref');

  if (preference) {
    return categoryAllowed(key, preference) ? getCookie(key) : null;
  }

  // Visitors who chose before the v2 category cookie existed.
  return Cookies.get('__hs_opt_out') === 'yes' ? null : getCookie(key);
};
